@if (card().state === 'pending' && card().kind === 'handover') {
  <article
    class="bg-elevated border-default overflow-hidden rounded-md border"
    [attr.aria-label]="handoverTitle()"
    [attr.aria-busy]="handingOver() !== null">
    <div class="flex items-start gap-2 px-3 pt-2.5 pb-1.5">
      <span
        class="bg-accent-interactive text-accent-main flex size-6 shrink-0 items-center justify-center rounded-full">
        <i [class]="ICONS.arrowsLeftRight"></i>
      </span>
      <h4 class="text-text-primary text-xs leading-6 font-semibold">
        {{ handoverTitle() }}
      </h4>
    </div>
    <p class="text-text-secondary pr-3 pb-2.5 pl-11 text-xs">
      {{ 'features.plan.edit.handover.message' | translate }}
    </p>
    <div class="bg-page border-weak flex flex-wrap items-center gap-2 border-t px-3 py-2">
      <span class="flex-1"></span>
      <button
        type="button"
        data-testid="handover-cancel"
        class="btn btn-cancel"
        [disabled]="assistant.streaming() || handingOver() !== null"
        (click)="answer(false)">
        {{ 'features.plan.edit.handover.cancel' | translate }}
      </button>
      <button
        type="button"
        data-testid="handover-discard"
        class="btn btn-danger"
        [disabled]="assistant.streaming() || handingOver() !== null"
        (click)="handOver('discard')">
        @if (handingOver() === 'discard') {
          <i
            aria-hidden="true"
            [class]="ICONS.circleNotch + ' animate-spin motion-reduce:animate-none'"></i>
          {{ 'features.plan.edit.handover.closing' | translate }}
        } @else {
          {{ 'features.plan.edit.handover.discard' | translate }}
        }
      </button>
      <button
        type="button"
        data-testid="handover-save"
        class="btn btn-primary"
        [disabled]="assistant.streaming() || handingOver() !== null"
        (click)="handOver('save')">
        @if (handingOver() === 'save') {
          <i
            aria-hidden="true"
            [class]="ICONS.circleNotch + ' animate-spin motion-reduce:animate-none'"></i>
          {{ 'features.plan.edit.handover.saving' | translate }}
        } @else {
          {{ 'features.plan.edit.handover.save' | translate }}
        }
      </button>
    </div>
  </article>
} @else if (card().state === 'pending') {
  <article
    class="bg-elevated overflow-hidden rounded-md border"
    [class]="destructive() ? 'border-danger/50' : 'border-default'"
    [attr.aria-label]="title()">
    <div class="flex items-start gap-2 px-3 pt-2.5 pb-1.5">
      <span
        class="flex size-6 shrink-0 items-center justify-center rounded-full"
        [class]="
          destructive()
            ? 'bg-danger-soft text-danger'
            : 'bg-accent-interactive text-accent-main'
        ">
        <i [class]="destructive() ? ICONS.warning : ICONS.pencil"></i>
      </span>
      <h4 class="text-text-primary text-xs leading-6 font-semibold">{{ title() }}</h4>
    </div>
    <div class="text-text-secondary flex flex-col gap-2 pr-3 pb-2.5 pl-11 text-xs">
      <p>{{ target() }}</p>
      @if (pills().length > 0) {
        <div class="flex flex-wrap gap-1">
          @for (pill of pills(); track pill.key) {
            <span
              class="border-default text-2xs inline-flex overflow-hidden rounded-xs border">
              <span class="bg-page text-text-secondary px-1.5">{{ pill.key }}</span>
              <span class="text-text-primary px-1.5 font-mono">{{ pill.value }}</span>
            </span>
          }
        </div>
      }
      <details>
        <summary class="text-accent-main w-fit cursor-pointer font-medium">
          {{ 'assistant.approvals.show_request' | translate }}
        </summary>
        <pre
          class="bg-page border-weak text-text-primary text-2xs mt-1.5 max-h-48 overflow-auto rounded-xs border p-2 font-mono"
          >{{ json() }}</pre
        >
      </details>
    </div>
    <div class="bg-page border-weak flex flex-wrap items-center gap-2 border-t px-3 py-2">
      @if (!destructive()) {
        <button
          type="button"
          data-testid="approval-always-allow"
          class="btn btn-transparent text-text-secondary"
          [disabled]="assistant.streaming()"
          (click)="answer(true, true)">
          {{ 'assistant.approvals.always_allow' | translate }}
        </button>
      }
      <span class="flex-1"></span>
      <button
        type="button"
        class="btn btn-cancel"
        [disabled]="assistant.streaming()"
        (click)="answer(false)">
        {{ 'assistant.approvals.reject' | translate }}
      </button>
      <button
        type="button"
        data-testid="approval-confirm"
        class="btn"
        [class]="destructive() ? 'btn-danger' : 'btn-primary'"
        [disabled]="assistant.streaming()"
        (click)="answer(true)">
        {{ confirmLabel() }}
      </button>
    </div>
  </article>
} @else {
  <div class="text-text-tertiary flex items-center gap-1.5 text-xs" role="status">
    <i [class]="card().state === 'approved' ? ICONS.check : ICONS.x"></i>
    <span
      class="font-mono"
      [class.line-through]="card().state === 'rejected' || card().state === 'superseded'">
      {{ title() }}
    </span>
    <span class="border-default text-2xs rounded-full border px-1.5 font-medium">
      {{ 'assistant.approvals.state.' + card().state | translate }}
    </span>
  </div>
}
